import { Injectable, inject } from '@angular/core';
import { SiaComponentApi } from '../apis/sia-component-api';
import { SiaTableInformations } from '../interfaces/sia-table-informations';

@Injectable({
  providedIn: 'root',
})
export class SiaComponentService {
  private api = inject(SiaComponentApi);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  updateActionGroupId(id: string, actionGroupId: string | null) {
    return this.api.updateActionGroupId(id, actionGroupId);
  }
  getTableInformations(
    componentId: string,
    connectionName?: string,
  ): Promise<SiaTableInformations[]> {
    return this.api.getTableInformations(componentId, connectionName);
  }
  getViewInformations(
    componentId: string,
    connectionName?: string,
  ): Promise<SiaTableInformations[]> {
    return this.api.getViewInformations(componentId, connectionName);
  }
  getViewInformationsByNameAndSchema(
    viewName: string,
    viewSchema: string,
  ): Promise<SiaTableInformations[]> {
    return this.api.getViewInformationsByNameAndSchema(viewName, viewSchema);
  }
  getPersistenceProperties(componentId: string): Promise<any> {
    if (!componentId) {
      return Promise.resolve(null);
    }
    return this.api.getPersistenceProperties(componentId);
  }
}
